/* tslint:disable */
/* eslint-disable */
/**
 * Portal messages API
 * API used to query portal messages.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@a2b-internet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PortalMessage } from '../model';
/**
 * PortalMessagesApi - axios parameter creator
 */
export const PortalMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve the currently active portal messages. Private messages are only returned when authenticated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalMessagesApiActive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/messages/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortalMessagesApi - functional programming interface
 */
export const PortalMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortalMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve the currently active portal messages. Private messages are only returned when authenticated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortalMessagesApiActive(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PortalMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortalMessagesApiActive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalMessagesApi.getPortalMessagesApiActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortalMessagesApi - factory interface
 */
export const PortalMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortalMessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve the currently active portal messages. Private messages are only returned when authenticated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalMessagesApiActive(options?: RawAxiosRequestConfig): AxiosPromise<Array<PortalMessage>> {
            return localVarFp.getPortalMessagesApiActive(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortalMessagesApi - object-oriented interface
 */
export class PortalMessagesApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve the currently active portal messages. Private messages are only returned when authenticated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPortalMessagesApiActive(options?: RawAxiosRequestConfig) {
        return PortalMessagesApiFp(this.configuration).getPortalMessagesApiActive(options).then((request) => request(this.axios, this.basePath));
    }
}

